import { whiteColor, hexToRgb, grayColor, blackColor, menuHoverBgColor } from 'assets/jss/material-dashboard-pro-react';

const newDropdownBackgroundColor = grayColor[27];

const sidebarSearchStyle = (theme) => ({
	searchWrapper: ({ newDashBoardEnabled }) => ({
		position: 'relative',
		zIndex: 11,
		margin: newDashBoardEnabled ? '0' : '16px 15px 0',
	}),
	inputWrapper: ({ newDashBoardEnabled, searchFocus }) => ({
		backgroundColor: newDashBoardEnabled ? (searchFocus ? whiteColor : newDropdownBackgroundColor) : grayColor[28],
		borderRadius: newDashBoardEnabled ? '12px' : '3px',
		[theme.breakpoints.up('sm')]: {
			borderRadius: newDashBoardEnabled ? '16px' : '3px',
		},
		padding: newDashBoardEnabled ? '12px 16px' : '12px 7px',
		'& .MuiFormControl-root': {
			paddingTop: 0,
			marginBottom: 0,
		},
		'& .MuiInputBase-input': {
			padding: 0,
		},
	}),
	searchIcon: {
		'& svg': {
			color: `${whiteColor}!important`,
		},
	},
	input: ({ newDashBoardEnabled }) => ({
		color: newDashBoardEnabled ? grayColor[20] : whiteColor,
		'&::placeholder': ({ newDashBoardEnabled }) => ({
			color: newDashBoardEnabled ? grayColor[20] : whiteColor,
		}),
		'&:focus::placeholder': ({ newDashBoardEnabled }) => ({
			color: newDashBoardEnabled
				? `rgba(${hexToRgb(grayColor[20])}, 0.51)`
				: `rgba(${hexToRgb(whiteColor)}, 0.51)`,
		}),
	}),
	dropdownWrapper: ({ dropdownMaxHeight, newDashBoardEnabled }) => ({
		backgroundColor: newDashBoardEnabled ? whiteColor : grayColor[28],
		position: 'absolute',
		width: '100%',
		marginTop: newDashBoardEnabled ? '0' : '4px',
		borderRadius: newDashBoardEnabled ? '0 0 16px 16px' : '3px',
		overflow: 'auto',
		maxHeight: `${dropdownMaxHeight}px`,
	}),
	singleSuggestion: ({ menuItemHeight, newDashBoardEnabled }) => ({
		height: `${menuItemHeight}px`,
		margin: newDashBoardEnabled ? '0 16px' : '0',
		'& a': ({ newDashBoardEnabled }) => ({
			height: '100%',
			cursor: 'pointer',
			padding: newDashBoardEnabled ? '0 11px 0 11px' : '0 11px 0 48px',
			alignItems: 'center',
			display: 'flex',
			justifyContent: 'flex-start',
			width: '100%',
			'& div': {
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				minWidth: 0,
			},
		}),
	}),
	noResults: ({ menuItemHeight }) => ({
		height: `${menuItemHeight}px`,
		padding: '0 11px 0 48px',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-start',
		width: '100%',
	}),
	noResultsNew: {
		padding: '24px 0',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
		'& img': {
			marginRight: '10px',
		},
	},

	activeSuggestion: ({ newDashBoardEnabled }) => ({
		backgroundColor: newDashBoardEnabled ? menuHoverBgColor : 'rgba(0, 0, 0, 0.54)',
		borderRadius: newDashBoardEnabled ? '16px' : '0',
	}),
	clearIconWrapper: {
		position: 'absolute',
		right: '5px',
		top: '50%',
		transform: 'translateY(-50%)',
		display: 'flex',
		padding: '4px',
		cursor: 'pointer',
		'& svg': ({ newDashBoardEnabled }) => ({
			width: newDashBoardEnabled ? 24 : 18,
			height: newDashBoardEnabled ? 24 : 18,
		}),
	},

	// new dashboard search bar start
	newInputWrapper: {
		height: '48px',
	},
	newDropdownWrapper: {
		boxShadow:
			'0 12px 17px 2px rgba(' +
			hexToRgb(blackColor) +
			', 0.04), 0 20px 22px 4px rgba(' +
			hexToRgb(blackColor) +
			', 0.04), 0 7px 8px 0px rgba(' +
			hexToRgb(blackColor) +
			', 0.06)',
	},
	show: {
		borderRadius: '16px 16px 0 0 !important',
		'&::after': {
			content: '""',
			display: 'block',
			marginTop: '16px',
			borderBottom: `1px solid ${grayColor[29]}`,
		},
	},
	searchFocus: {
		boxShadow:
			'0 10px 20px -12px rgba(' +
			hexToRgb(blackColor) +
			', 0.42), 0 3px 20px 0px rgba(' +
			hexToRgb(blackColor) +
			', 0.12), 0 8px 10px -5px rgba(' +
			hexToRgb(blackColor) +
			', 0.2)',
		transition: 'all 150ms ease 0s',
	},

	// new dashboard search bar end
});

export default sidebarSearchStyle;
